import { AlertTierDot } from "@/components/operations/alert-tier-badge";
import { computeAlertTier, type AlertTier } from "@/lib/alert-tier";
import { cn } from "@/lib/utils";

interface StatusWithAlertDotProps {
  status: string;
  currentStock: number | string | null;
  reorderLevel: number | string | null | undefined;
  safetyStock: number | string | null | undefined;
  maxStockLevel?: number | string | null | undefined;
  inventoryTracked?: boolean;
}

const STATUS_COLORS: Record<string, string> = {
  Active: "bg-green-100 text-green-700",
  Discontinued: "bg-red-100 text-red-700",
  Seasonal: "bg-blue-100 text-blue-700",
  Archived: "bg-zinc-100 text-zinc-700",
};

export function StatusWithAlertDot({ status, currentStock, reorderLevel, safetyStock, maxStockLevel, inventoryTracked = true }: StatusWithAlertDotProps) {
  const configured = inventoryTracked && (Number(maxStockLevel ?? 0) > 0 || Number(reorderLevel ?? 0) > 0);
  const tier: AlertTier = configured ? computeAlertTier({ currentStock, maxStockLevel, reorderLevel, safetyStock }) : "Healthy";
  const statusBg = STATUS_COLORS[status] ?? "bg-zinc-100 text-zinc-700";
  return (
    <div className="flex items-center gap-2">
      <AlertTierDot tier={tier} currentStock={currentStock} reorderLevel={reorderLevel} configured={configured} />
      <span className={cn("inline-flex items-center rounded px-2 py-0.5 text-xs font-medium", statusBg)}>
        {status}
      </span>
    </div>
  );
}
